import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import GrabLogo from "../../assets/images/grablogo.png";
const useStyles = makeStyles((theme) => ({
  iconButton: {
    width: "30%",
    height: "30%",
    margin: "auto",
  },
  mobileIconButton: {
    width: "50%",
    height: "50%",
    margin: "auto",
    [theme.breakpoints.between("sm", "md")]: {
      width: "40%",
      height: "40%",
      margin: "auto",
    },
  },
  grab: {
    backgroundColor: "white",
    color: "green",
    height: "70px",
    width: "20rem",
    animation: "float 5s ease-in-out infinite",
    [theme.breakpoints.down("lg")]: {
      backgroundColor: "white",
      color: "green",
      height: "50px",
      display: "flex",
      width: "15rem",
      justifyContent: "space-between",
      animation: "float 5s ease-in-out infinite",
    },
  },
  smallerText: {
    marginRight: "1rem",
    whiteSpace: "nowrap",
  },
}));
export default function GrabButton() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <Button
      className={classes.grab}
      variant="contained"
      target="_blank"
      rel="noreferrer"
      href="https://food.grab.com/vn/vi/restaurant/b%C3%BAn-b%E1%BA%AFp-b%C3%B2-o-nh%C6%B0-delivery/5-C2EVEKNCJVCAE2"
      startIcon={
        <img
          src={GrabLogo}
          alt="grab-logo"
          className={matches ? classes.mobileIconButton : classes.iconButton}
        />
      }
    >
      <Typography
        variant={matches ? "subtitle1" : "h6"}
        className={classes.smallerText}
      >
        ĐẶT NGAY
      </Typography>
    </Button>
  );
}
